import { ConfigService } from '../services';
import { KeycloakService } from 'keycloak-angular';

export function configServiceFactory(config: ConfigService, keycloak: KeycloakService): () => Promise<any> {
	return (): Promise<any> => {
		return new Promise((resolve: any, reject: any) => {
			config.loadConfig().then((configSuccess: boolean) => {
				if (!configSuccess) {
					reject(configSuccess);
				}
				const cfg = config.getConfig();
				if (!cfg.keycloak.enabled) {
					return true;
				}
				return keycloak.init({
					config: cfg.keycloak.config,
					loadUserProfileAtStartUp: true,
					initOptions: {
						onLoad: 'check-sso',
						silentCheckSsoRedirectUri:
							window.location.origin + '/assets/silent-check-sso.html',
					},
					bearerExcludedUrls: ['/assets']
				});
			}).then((configSuccess: boolean) => {
				resolve(true);
			}).catch(() => {
				reject();
			});
		});
	};
}
